import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Star, ShieldCheck } from "lucide-react";
import { api } from "../lib/api";

export default function Testimonials({ slug = null, limit = 6, heading = null }) {
    const { data: items = [], isLoading } = useQuery({
        queryKey: ["testimonials"],
        queryFn: async () => (await api.get("/testimonials")).data,
    });

    const filtered = (slug ? items.filter((t) => t.product_slug === slug) : items).slice(0, limit);

    if (isLoading) return <div className="text-zinc-500">Loading…</div>;
    if (filtered.length === 0) return null;

    return (
        <>
        {heading && (
            <div className="mb-10">
                <div className="eyebrow mb-3">Reviews</div>
                <h2 className="font-display text-3xl md:text-4xl uppercase tracking-tight">{heading}</h2>
            </div>
        )}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="testimonials">
            {filtered.map((t) => (
                <div key={t.id} className="p-7 rounded-sm bg-bg1 border border-white/10 hover:border-lime/40 transition-colors" data-testid={`testimonial-${t.name.replace(/[^a-z0-9]/gi,'-').toLowerCase()}`}>
                    <div className="flex items-center gap-1 mb-3 text-gold">
                        {[...Array(t.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold" />)}
                    </div>
                    <h4 className="font-display text-lg uppercase tracking-tight">{t.title}</h4>
                    <p className="mt-2 text-zinc-300 leading-relaxed">&ldquo;{t.quote}&rdquo;</p>
                    <div className="mt-5 pt-4 border-t border-white/5 flex items-center justify-between">
                        <div className="text-sm">
                            <div className="text-white font-semibold">{t.name}{t.age ? `, ${t.age}` : ""}</div>
                            <div className="text-xs text-zinc-500 uppercase tracking-widest">{t.location}</div>
                        </div>
                        {t.verified && (
                            <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-lime">
                                <ShieldCheck className="w-3 h-3" /> Verified
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
        </>
    );
}
